// extracted by mini-css-extract-plugin
export default {"headerText":"Index_headerText__h5Sw6","sec1":"Index_sec1__wNfbE","sec2":"Index_sec2__3Ava4","sec4":"Index_sec4__9j6SJ","sec4Content":"Index_sec4Content__GmmNT"};